<template>
  <v-app id="app">
    <Drawer v-show="this.$route.name !== 'loading'"></Drawer>
    <Content></Content>
  </v-app>
</template>

<script>
import Content from "./components/Content";
import Drawer from "./components/Drawer";
export default {
  name: "PortalIndex",
  components: {
    Drawer,
    Content
  }
};
</script>

<style scoped></style>
